export default "__VITE_ASSET__25186778__"